import { RowDataAdmin } from "../../components/AdminPage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the AdminTable factory
 */
class AdminRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/admin/read-range"
        this.accessData = "admins"
    }

    create(admin: any): RowDataAdmin {
        const rowDataAdmin: RowDataAdmin = {
            name: admin.fullname,
            uid: admin.admin_id,
            email: admin.email,
            password: "",
            reenterPassword: "",
            action: "",

            role: admin.role,
        };
        return rowDataAdmin;
    }
}

let adminRow: AdminRow | null = null;

export default function getAdminRow(): AdminRow {
    if (adminRow === null)
        adminRow = new AdminRow()
    return adminRow
}